import React, { Fragment } from "react";

import {
  IconButton,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";

import { AppBar } from "react-admin";

import Announcements from "../../components/common/Announcements";

const USER_GUIDE_URL = "/docs/carrier-app-user-guide.pdf";

const useStyles = makeStyles((theme) => ({
  title: {
    flex: 1,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  hidden: {
    display: "none",
  },
  logo: {
    margin: "auto",
    paddingTop: theme.spacing(1),
  },
  spacer: { flex: 1 },
  selector: {
    marginLeft: theme.spacing(2),
    minWidth: 192,
  },
}));

export const CarrierAppBar = (props, userMenu) => {
  const classes = useStyles();
  const lteSmall = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const svgLogo = "/logo_transloads_white.svg";

  const helpButton = (
    <Tooltip title="User guide">
      <IconButton
        color="inherit"
        aria-label="Open the carrier portal user guide"
        href={USER_GUIDE_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        <HelpOutlineIcon />
      </IconButton>
    </Tooltip>
  );

  return lteSmall ? (
    <>
      <AppBar {...props} color="primary" userMenu={userMenu}>
        <span className={classes.spacer} />
        <Typography
          variant="h6"
          color="inherit"
          id="react-admin-title"
          className={classes.hidden}
        />
        <div className={classes.logo}>
          <img src={svgLogo} alt="transloads.co logo" height="30px" />
        </div>
        <span className={classes.spacer} />
        {helpButton}
      </AppBar>
      <Announcements />
    </>
  ) : (
    <>
      {/* container={Fragment} makes the appBar fixed */}
      <AppBar
        {...props}
        color="primary"
        userMenu={userMenu}
        container={Fragment}
      >
        <Typography
          variant="h6"
          color="inherit"
          id="react-admin-title"
          className={classes.title}
        />
        <div className={classes.logo}>
          <img src={svgLogo} alt="transloads.co logo" height="30px" />
        </div>
        <span className={classes.spacer} />
        {helpButton}
      </AppBar>
      <Announcements />
    </>
  );
};
